export const reportHeaderForm = (city, parentCompany, companyList) => [
  {
    name: "allCity",
    placeHolder: "All Cities",
    menuList: city,
  },
  {
    name: "parentCompany",
    placeHolder: "All Parent Companies",
    menuList: parentCompany,
  },
  {
    name: "allCompanies",
    placeHolder: "All Companies",
    menuList: companyList,
  },
];

export const misHeaderForm = (city, companyList) => [
  {
    name: "allCity",
    placeHolder: "All Cities",
    menuList: city,
  },
  {
    name: "allCompanies",
    placeHolder: "All Companies",
    menuList: companyList,
  },
];
